import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {HrService} from '../hr.service';
import {FabMessageService} from '@fabric/components/message';
import {PersonalService} from '../../personal/personal.service';
import {AuthenticationService} from '../../core/authentication/authentication.service';
import {FabThemeService} from '@fabric/components/theme';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Employee} from '../../admin/models/employee.model';
import {Team} from '../../admin/models/team.model';
import {NgForm} from '@angular/forms';
import {VacationTrackerUser} from '../../core/user/vacation-tracker-user';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';

@Component({
    selector: 'app-employee-vacation-allowance-override',
    templateUrl: './employee-vacation-allowance-override.component.html',
    styleUrls: ['./employee-vacation-allowance-override.component.scss']
})
export class EmployeeVacationAllowanceOverrideComponent implements OnInit {

    public employee = {} as Employee;
    public teamData: Team[] = [];
    public user = {} as VacationTrackerUser;
    public isPageLoading = false;
    public role = {} as any;
    public roles = [
        {value: 'ABT_HR', displayValue: 'HR'},
        {value: 'ABT_MANAGER', displayValue: 'Manager'},
        {value: 'ABT_EMPLOYEE', displayValue: 'Employee'}];
    public oldAllowance = 0;
    public oldCarryOver = 0;
    public newAllowance = 0;
    public newCarryOver = 0;
    public difference = 0;
    public carryOverDifference = 0;
    public overrideOptions = [{value: 'allowance', displayValue: 'Allowance'}, {value: 'carry_over', displayValue: 'Carry Over'}];
    public overrideType: any;
    @ViewChild('form') private readonly form!: NgForm;
    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
    @ViewChild(MatSort) sort: MatSort | undefined;

    constructor(private readonly hrService: HrService,
                private readonly messageService: FabMessageService,
                private readonly personalService: PersonalService,
                private readonly authService: AuthenticationService,
                public readonly themeService: FabThemeService,
                public dialogRef: MatDialogRef<[]>,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }

    ngOnInit(): void {
        this.personalService.fetchEmployeeByGmin(this.selectedData[0].gmin).subscribe({
            next: (data) => {
                this.employee = data;
                this.user.roles = [this.roles[2].value];
                this.employee.updatedBy = this.authService.userInfo.gmin || '';
                this.teamData = this.selectedData.teamData;
                this.oldAllowance = this.selectedData[0].vacationAllowance;
                this.oldCarryOver = this.selectedData[0].vacationAllowanceCarryover;
                this.isPageLoading = false;
            },
            error: () => this.messageService.displayErrorMessage('Error fetching data')
        });
        this.isPageLoading = true;
    }

    /**
     * Closes the popup
     */
    close(): void {
        this.dialogRef.close();
    }

    /**
     * Calculates the difference between the old allowance and new allowance
     * and updates the remaining vacation allowance
     */
    overwriteDaysAllowance(): void {
        this.newAllowance = this.selectedData[0].vacationAllowance;
        this.difference = this.newAllowance - this.oldAllowance;
        this.selectedData[0].vacationAllowanceRemaining =
            this.selectedData[0].vacationAllowanceRemaining + this.difference;
        for (const element of this.employee.employeeVacationAllowance) {
            if (this.selectedData[0].year === element.year) {
                element.vacationAllowance = this.newAllowance;
                element.vacationAllowanceRemaining =
                    element.vacationAllowanceRemaining + this.difference;
            }
        }
    }

    /**
     * Calculates the difference between the old allowance and new allowance
     * and updates the remaining vacation allowance
     */
    overwriteCarryOverAllowance(): void {
        this.newCarryOver = this.selectedData[0].vacationAllowanceCarryover;
        this.carryOverDifference = this.newCarryOver - this.oldCarryOver;
        this.selectedData[0].vacationAllowanceRemaining =
            this.selectedData[0].vacationAllowanceRemaining + this.carryOverDifference;
        for (const element of this.employee.employeeVacationAllowance) {
            if (this.selectedData[0].year === element.year) {
                element.vacationAllowanceCarryover = this.newCarryOver;
                element.vacationAllowanceRemaining =
                    element.vacationAllowanceRemaining + this.carryOverDifference;
            }
        }
    }

    /**
     * Submits the form to create a new employee.
     * Uses people search to find an employee and populate the form.
     */
    submitForm(): void {
        this.role = this.user.roles;
        if (this.overrideType === 'allowance') {
            this.overwriteDaysAllowance();
        } else {
            this.overwriteCarryOverAllowance();
        }
        this.isPageLoading = true;
        this.hrService.updateEmployee(this.employee, this.role).subscribe({
            next: () => {
                this.messageService.displayMessage('Request submitted successfully');
                this.isPageLoading = false;
                this.close();
            }, error: () => {
                this.messageService.displayErrorMessage('Request submission failed');
                this.isPageLoading = false;
            }
        });
    }
}
